<template>
  <v-app>
    <v-app-bar
      app
    >
      <a href="#/">
        <v-img
          alt="Rosa Golfen Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/img/logo.png')"
          transition="scale-transition"
          width="50"
          height="50"
        />
      </a>

      <div class="flex-grow-1"></div>

      <a href="https://www.wip.se" target="_blank">
        <v-img
          alt="Mobilized by WIP"
          class="shrink mr-2"
          contain
          :src="require('./assets/img/mobilized.png')"
          transition="scale-transition"
          :height="54*0.65"
          :width="219*0.65"
        />
      </a>

      <template v-if="$vuetify.breakpoint.mdAndUp">
        <div class="flex-grow-1"></div>

        <div style="width: 50px;"></div>
      </template>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
</style>
